import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  template: '<div id="loader-bar" [class.margin]="loaderService.margin$ | async"><mat-progress-bar *ngIf="loaderService.loading$ | async" color="primary" mode="indeterminate"></mat-progress-bar></div>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {

  constructor(public loaderService: LoaderService) { }

}
